/*
 * Copyright (c) 2021. Michael Clovis
 * This program is free software: you can redistribute it and/or modify
 *     it under the terms of the GNU Affero General Public License as published by
 *     the Free Software Foundation, either version 3 of the License, or
 *     (at your option) any later version.
 *
 *     This program is distributed in the hope that it will be useful,
 *     but WITHOUT ANY WARRANTY; without even the implied warranty of
 *     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *     GNU Affero General Public License for more details.
 *
 *     You should have received a copy of the GNU Affero General Public License
 *     along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import {createApp} from 'vue'
import App from './App.vue'



import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
//import "bootstrap-icons/bootstrap-icons.svg";
import {BootstrapIconsPlugin} from 'bootstrap-icons-vue';

import {createMemoryHistory, createRouter, createWebHistory} from 'vue-router'

// const routes =[
//     {
//         path: "/login",
//         name: "Login",
//         component: Login ,
//         // props:{users:users}
//     },
//     {
//         path:"/",
//         name:"Home",
//         component: Home,
//     },
//
//     {
//         path: "/admin/",
//         name: "Admin",
//         component: Admin,
//         redirect:"/manageUsers/",
//         children:[
//             {path:"manageUsers",name:"ManageUsers",component:ManageUsers},
//             {path: "manageJobs",name:"ManageJobs",component: ManageJobs }
//         ]
//     }
// ]
//
// const router = createRouter({
//     history: createMemoryHistory(),
//     routes,
//     linkActiveClass: 'active'
//
// })

//import router from "./router/index"
//import store from "@/store/store";

const routes =[
    {
        path: "/login",
        name: "Login",
        component: Login ,
        // props:{users:users}
    },
    {
        path:"/",
        name:"Home",
        component: Home,
    },

    {
        path: "/admin/",
        name: "Admin",
        component: Admin,
        redirect:"/manageUsers/",
        children:[
            {path:"manageUsers",name:"ManageUsers",component:ManageUsers},
            {path: "manageJobs",name:"ManageJobs",component: ManageJobs },
            {path:"manageTimeCards",name:"ManageTimeCards",component: ManageTimeCards}
        ]
    }
]


const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: 'active'
});
router.beforeEach(function (to,from,next){

    if(to.path.startsWith("/admin")){

        if(store.state.loggedInUser && store.state.loggedInUser.isAdmin){
            next();
        }else if(!store.state.loggedInUser){
            next({name:"Login"});
        }
        else{
            next({name:"Home"});
        }

    }else if (to.path.startsWith("/") && !to.path.startsWith("/login")){
        //console.log(store);
        if(store.state.loggedInUser){
            next();
        }else{
            // console.log("redirecting...")
            next({name:"Login"})
        }

    }
    else{
        next();
    }
    //next();
});


// const state = {
//     appointments:[],
//     loggedInUser: null,
//     users:[],
//     jobs: [],
// };

// const getters = {
//     hasAdmin(){
//         let idx = state.users.findIndex(elem =>{return elem.isAdmin ===true})
//         return idx > -1;
//     },
//     AppointmentLength(){
//         return state.appointments.length;
//     },
//     NoUsers(){
//         return state.users.length ===0 || state.users.length ===1 && state.users[0].fName === "admin";
//     },
//     NoJobs(){
//         return state.jobs.length ===0;
//     },
//     FirstThing(){
//         //console.log("users length: "+ state.users.length);
//         //
//         let isFirstThing = state.users.length ===0 || (state.users.length >=1 && state.users[0].fName === "admin") ;
//         if(state.users.length > 1 && state.users[0].fName === "admin"){
//             // remove the admin users
//             let idx = state.users.findIndex(elem => {return elem.fName === state.users[0].fName })
//             if(idx > -1) {
//                 state.users.splice(idx, 1);
//             }
//         }
//         return isFirstThing;
//     }
//
// };
//
// const mutations ={
//     setRota(state,appts){
//         state.appointments = appts;
//     },
//     setUsers(state,users){
//         state.users = users;
//     },
//     setJobs(state,jobs){
//         state.jobs = jobs;
//     },
//     addAppointment(state,appt){
//         //console.log("Commit addAppointment")
//         state.appointments.push(appt);
//     },
//     addUser(state,user){
//         state.users.push(user);
//     },
//     addJob(state,job){
//         state.jobs.push(job);
//     },
//     editUser(state, user){
//         let idx = state.users.findIndex(elem =>{return elem.id === user.id});
//         if(idx > -1) {
//             state.users.splice(idx, 1, user);
//         }
//     },
//     editAppointment(state,appt){
//         let idx = state.appointments.findIndex(elem =>{return elem.id === appt.id});
//         if(idx > -1) {
//             state.appointments.splice(idx, 1, appt);
//         }
//     },
//     editJob(state,job){
//         let idx = state.jobs.findIndex(elem =>{return elem.id === job.id});
//         if(idx >-1) {
//             state.jobs.splice(idx, 1, job);
//         }
//     },
//     deleteAppointment(state,appt){
//         let idx = state.appointments.findIndex(elem =>{return elem.id === appt.id});
//         if(idx > -1) {
//             state.appointments.splice(idx, 1);
//         }
//     },
//     deleteJob(state,job){
//         let idx = state.jobs.findIndex(elem => {
//             return elem.id === job.id
//         });
//         if (idx > -1) {
//             state.jobs.splice(idx, 1);
//         }
//     },
//     deleteUser(state, user) {
//         let idx = state.users.findIndex(elem => {
//             return elem.id === user.id
//         });
//         if (idx > -1) {
//             state.users.splice(idx, 1);
//         }
//     },
//     setLoggedInUser(state, loggedInUser) {
//
//         setTimeout(() => {
//             state.loggedInUser = null;
//         }, 500);
//     },
//
// };
import store from "./store/store"
// import { createStore } from 'vuex'
// const store = createStore({
//    state:state,
//     mutations:mutations,
//     getters:getters,
// })
import axios from 'axios';
import VueAxios from 'vue-axios';
import Login from "@/components/Login.vue";
import Home from "@/views/Home.vue";
import Admin from "@/views/Admin.vue";
import ManageUsers from "@/views/ManageUsers.vue";
import ManageJobs from "@/views/ManageJobs.vue";
import ManageTimeCards from "@/views/ManageTimeCards.vue";


//axios.defaults.baseURL ="https://fwecfvl8fa.execute-api.us-east-1.amazonaws.com/prod";   // remove this later


const app = createApp(App);
//app.use(bootstrap);h
app.use(router);
app.use(store);
app.use(VueAxios, axios);
app.use(BootstrapIconsPlugin);
app.mount('#app')

